/* eslint-disable max-len */

/**
 * A utility function that returns a promise. The promise resolves when condition is met
 * otherwise gets rejected when maxWait exaust.
 *
 * @param {boolean} runCondition - condition upon which promise resolves / reject
 * @param {Number} maxWait - max time in ms before promise is rejected
 */
// eslint-disable-implicit-arrow-linebreak
var awaitCondition = function awaitCondition(runCondition) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$maxWait = _ref.maxWait,
      maxWait = _ref$maxWait === void 0 ? 5000 : _ref$maxWait;

  return new Promise(function (resolve, reject) {
    var interval = 10;
    var time = 0;
    var ID = window.setInterval(function () {
      if (runCondition()) {
        resolve();
        clearInterval(ID);
      } else {
        time += interval;

        if (time > maxWait) {
          clearInterval(ID);
          reject();
        }
      }
    }, interval);
  });
};

export default awaitCondition;